import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withHandlers } from 'recompose';
import { getUserUrlPrefix, getActiveBrandId, getShopNamesById } from '../../../../auth/selectors';
import { fetchLocations } from '../store/actions';
import {
  getPoLocations,
  isLoadingLocations,
  getAddressesById,
} from '../store/selectors';
import withLoading from '../../../../common/withLoading';
import { canUserModifyProducts } from '../../../../common/helpers/users';

const LocationListContainer = compose(
  connect(
    state => ({
      baseUrl: `${getUserUrlPrefix(state)}/products/purchase-orders/locations`,
      canEditProducts: canUserModifyProducts(state.auth.permissions),
      listItems: getPoLocations(state),
      loadingLocations: isLoadingLocations(state),
      addressesById: getAddressesById(state),
      shopNamesById: getShopNamesById(state),
      brandId: getActiveBrandId(state),
    }),
    {
      fetchLocations,
    }
  ),
  withProps(props => ({
    showLoading: props.loadingLocations,
  })),
  withHandlers({
    goToEditing: props => (locationId) => {
      props.router.push(`${props.baseUrl}/${locationId}/edit`);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchLocations(this.props.brandId);
    },
  }),
  withLoading,
);

export default LocationListContainer;
